import React, { useMemo, useRef, useState } from "react";
import { Button } from "antd";
import { asset, normalizeMemberProfile } from "../memberData";
import MemberAvatar from "../member-avatar/MemberAvatar";
import CustomerOverview from "../customer-overview/CustomerOverview";
import CustomerProfile from "../customer-profile/CustomerProfile";
import CustomerPlaylist from "../customer-playlist/CustomerPlaylist";
import CustomerBranches from "../customer-branches/CustomerBranches";
import CustomerLeaderboard from "../customer-leaderboard/CustomerLeaderboard";

const pages = [
  ["overview", "Tổng quan", "overview-imgBoxiconsHomeAlt2Filled.svg"],
  ["profile", "Thông tin người dùng", "overview-imgFrame48095422.svg"],
  ["playlist", "Playlist của bạn", "overview-imgGroup.svg"],
  ["leaderboard", "Bảng xếp hạng", "overview-imgAntDesignStarFilled.svg"],
  ["branches", "Cơ sở", "overview-imgBoxiconsLocationFilled.svg"],
];
const mobileLabels = { overview: "Tổng quan", profile: "Tài khoản", playlist: "Playlist", leaderboard: "Xếp hạng", branches: "Cơ sở" };
export default function CustomerPortal({ profile, onSwitchAccount, onClose, onSaveProfile, saving, profileError, profileNotice, onSearchSongs }) {
  const member = useMemo(() => normalizeMemberProfile(profile), [profile]);
  const [page, setPage] = useState("overview");
  const [playlistOpened, setPlaylistOpened] = useState(false);
  const contentRef = useRef(null);
  const choosePage = (next) => {
    if (next === page) return;
    if (next === "playlist") setPlaylistOpened(true);
    setPage(next);
    contentRef.current?.scrollTo?.(0, 0);
  };
  const navigation = <>
    <div className="member-sidebar-user"><MemberAvatar member={member} /><strong>{member.name}</strong></div>
    <nav aria-label="Khu vực thành viên">
      {pages.map(([key, label, icon]) => <button key={key} type="button" aria-current={page === key ? "page" : undefined} onClick={() => choosePage(key)}>
        <img src={asset(icon)} alt="" /><span>{label}</span>
      </button>)}
    </nav>
    <Button className="member-switch" onClick={onSwitchAccount} icon={<img src={asset("overview-imgFluentMdl2ReturnToSession.svg")} alt="" />}>Tra cứu số khác</Button>
  </>;
  return <div className={`member-portal member-tier-${member.tier} ${page === "leaderboard" ? "member-ranking-theme" : ""}`}>
    <div className="member-mobile-title">{pages.find(([key]) => key === page)[1]}</div>
    <aside className="member-sidebar">{navigation}</aside>
    <div className={`member-content member-content-${page}`} ref={contentRef}>
      {page === "overview" && <CustomerOverview member={member} />}
      {page === "profile" && <CustomerProfile member={member} onSave={onSaveProfile} saving={saving} error={profileError} notice={profileNotice} />}
      {playlistOpened && <div className="member-playlist-slot" hidden={page !== "playlist"}><CustomerPlaylist member={member} searchSongs={onSearchSongs} /></div>}
      {page === "branches" && <CustomerBranches member={member} onClose={onClose} />}
      {page === "leaderboard" && <CustomerLeaderboard />}
      {page === "profile" && <Button className="member-mobile-switch" onClick={onSwitchAccount}>Tra cứu số khác</Button>}
    </div>
    <nav className="member-bottom-nav" aria-label="Điều hướng thành viên mobile">
      {pages.map(([key, label, icon]) => <button key={key} type="button" aria-label={label} aria-current={page === key ? "page" : undefined} onClick={() => choosePage(key)}>
        <span className="member-bottom-icon"><img src={asset(icon)} alt="" /></span><span>{mobileLabels[key]}</span>
      </button>)}
    </nav>
  </div>;
}
